module.exports = __webpack_public_path__ + "static/media/CARD_SILVER@3x.c3a24237.png";